import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {User} from '../model/user';
import {ApiResponse} from '../model/api-response';
import {Injectable} from '@angular/core';
import {UserUpdate} from '../model/user-update';
import {BaseService} from './base.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {

  constructor(private httpClient: HttpClient) {
    super();
  }

  getMyUserData(): Observable<ApiResponse<User>> {
    return this.httpClient.get<ApiResponse<User>>(`${this.baseUrl}/users/me`)
  }

  updateMyUserData(userUpdate: UserUpdate): Observable<ApiResponse<User>> {
    return this.httpClient.post<ApiResponse<User>>(`${this.baseUrl}/users/me/update`, userUpdate);
  }

  deleteUser(id: number): Observable<ApiResponse<string>> {
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/users/${id}`);
  }

  getAllUsers(): Observable<ApiResponse<Array<User>>> {
    return this.httpClient.get<ApiResponse<Array<User>>>(`${this.baseUrl}/users`);
  }

  getUserByUsername(username: string): Observable<ApiResponse<User>> {
    return this.httpClient.get<ApiResponse<User>>(`${this.baseUrl}/users/search/username/${username}`);
  }

  getUsersByUsernamePartial(username: string): Observable<ApiResponse<Array<User>>> {
    return this.httpClient.get<ApiResponse<Array<User>>>(`${this.baseUrl}/users/search/multiple/username/${username}`);
  }

  getUserById(id: number): Observable<ApiResponse<User>> {
    return this.httpClient.get<ApiResponse<User>>(`${this.baseUrl}/users/search/id/${id}`);
  }

  setUserActivation(id: number, active: boolean): Observable<ApiResponse<User>> {
    return this.httpClient.put<ApiResponse<User>>(`${this.baseUrl}/users/${id}/activation`, { active });
  }

}





